module.exports = __webpack_public_path__ + "static/img/subscribe.aa5bea3e.gif";